/* @flow */

import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from './home';

export default class HomeWrapper extends React.Component {
  render(): ?React.Element<any> {
    return (
      <Switch>
        <Route path="/@:lat,:lng,:zoom\z" component={Home} />
        <Route path="/place/:placeId/@:lat,:lng,:zoom\z" component={Home} />
        <Route path="/place/:placeId" exact component={Home} />
        <Route path="/search/:seachQuery" component={Home} />
        <Route path="/view/:viewId/@:lat,:lng,:zoom\z" component={Home} />
        <Route path="/view/:viewId/place/:placeId/@:lat,:lng,:zoom\z" component={Home} />
        <Route path="/view/:viewId/place/:placeId" exact component={Home} />
        <Route path="/view/:viewId/search/:seachQuery" component={Home} />
        <Route path="/view/:viewId" exact component={Home} />
        <Route path="/" exact component={Home} />
      </Switch>
    );
  }
}
